// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import { ImageAspectRatio } from "../../../components/image_aspect_ratio/ImageAspectRatio";
import { ImageFader } from "../../../components/image_fader/ImageFader";
import { ScrollIndicator } from "../../../components/scroll_indicator/ScrollIndicator";
import Lottie from "lottie-web";
import { AnimationConfigWithData } from "lottie-web";
import animationData from "../../../../public/assets/mb_aufbauhersteller_header.json";
import { Api } from "../../../api";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
    ImageFader,
    ScrollIndicator,
  },
})
export class StageFrontpageAnimationModule extends ModuleBase {
  private count: number = 0;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  async created() {
    let products = await Api.conversionWorldService.getProducts(
      {
        page_id: this.$store.page.page!.id,
        query: "",
        branchen: [],
        countries: [],
        solutions: [],
        model_series: [],
        bodybuilder: [],
      },
      "both",
      undefined,
      1
    );

    this.count = products.pagination!.total_count!;
  }

  mounted() {
    this.startAnimation();
  }

  private startAnimation() {
    let container = <HTMLElement>this.$refs["lottie"];

    let params: AnimationConfigWithData = {
      container: container,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };
    let anim = Lottie.loadAnimation(params);
  }
}
